export default "__VITE_ASSET__B7tJIx1r__"